import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import { FaPlus } from "react-icons/fa";
import CreateTransactionModal from "./createTransaction";
import { Toast } from "primereact/toast";
import ReturnComponent from "./stockComponent/returnComponent";
import TradeComponent from "./stockComponent/tradeComponent";
import RiskComponent from "./stockComponent/riskCompoenent";
import MovementComponent from "./stockComponent/movementComponent";
import { formatNumber, truncateText } from "../../../../../utility/helper";
import {
  deleteTransaction,
  getCompanyprofileService,
  getFutureTransaction,
  getRoiService,
  getStockTransaction,
  getUserAssets,
} from "../../../../../services/transaction";
import { filterDropdownOptions } from "../../../../../utility/data";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const dropdownOptions = [
    { name: "INCOME" },
    { name: "EXPENSE" },
    { name: "IN" },
    { name: "OUT" },
  ];
  const [type, setType] = useState("");
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [limit, setLimit] = useState(20);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [filterType, setFilterType] = useState(filterDropdownOptions[0]);
  const [viewTransaction, setViewTransaction] = useState([]);
  const [viewFutureTransaction, setViewFutureTransaction] = useState([]);
  const [graphROI, setGraphROI] = useState([]);
  const [companyDetails, setCompanyDetails] = useState({});
  const [actionTypes, setActionTypes] = useState("Create");
  const [selectedButton, setSelectedButton] = useState("Return");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const toast = useRef(null);
  const dispatch = useDispatch();
  const userAssets = useSelector((state) => state.userAssets.data);
  const selectedAsset = useSelector((state) => state.userAssets.selectedAsset);
  const location = useLocation();
  const id = location?.state?.id || null;

  useEffect(() => {
    if (selectedAsset) {
      GetTransactionData();
      GetFutureTransactionData();
      GetRoiData();
      GetCompanyprofile();
    }
  }, [selectedAsset, filterType, page]);

 useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 2, selectedAssetId: id }));
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  const GetRoiData = async () => {
    setLoading(true);
    try {
      const response = await getRoiService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setGraphROI(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetCompanyprofile = async () => {
    setLoading(true);
    try {
      const response = await getCompanyprofileService(
        selectedAsset?.symbol,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setCompanyDetails(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      console.error("Error fetching company profile:", err);
      setCompanyDetails({});
    } finally {
      setLoading(false);
    }
  };

  const GetTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getStockTransaction(
        selectedAsset?.id,
        page * limit,
        limit,
        filterType,
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const GetFutureTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getFutureTransaction(
        selectedAsset?.id,
        page,
        limit,
        filterType,
        2,
        accessToken
      );
      if (response.status === 200) {
        setViewFutureTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleTransactionDelete = async (user) => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const response = await deleteTransaction(accessToken, user?.id);
      if (response) {
        fetchUserAssets();
        GetRoiData();
        GetTransactionData();
        GetFutureTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "bg-primary hover:border-white text-gray-300 font-bold py-2 px-4 rounded border border-[rgb(161,147,147)]",
      confirmClass:
        "bg-secondary hover:bg-gray-400 font-bold py-2 px-4 rounded ml-4 text-primary border",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div className="text-gray-400">
        <CustomDropdown
          options={userAssets}
          name={selectedAsset ? selectedAsset?.name : "Select Asset"}
          assetId={selectedAsset ? selectedAsset?.id : "Select Asset"}
          onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
          returnFullObject={true}
          truncateText={truncateText}
          size={19}
          className="inline-flex whitespace-nowrap justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md hover:border hover:border-secondary"
        />
      </div>

      <div className="grid md:grid-cols-12 grid-cols-4">
        <div className="md:col-span-4 col-span-4 text-sm font-bold">
          <div className="grid md:grid-cols-4 grid-cols-4 gap-1">
            <div className="ml-1 col-span-2">{selectedAsset?.name}</div>
            <div className="flex justify-around whitespace-nowrap ">
              <span className="mr-4">CHF</span>{" "}
              {formatNumber(
                viewTransaction?.remaining_balance
                  ? viewTransaction?.remaining_balance
                  : 0
              )}
            </div>
            <div
              className={`flex justify-around whitespace-nowrap ${
                graphROI?.avg_roi < 0 ? "text-expense" : "text-secondary"
              }`}
            >
              {formatNumber(
                graphROI?.avg_roi
                  ? Number((graphROI.avg_roi * 100).toFixed(2))
                  : 0
              )}
              %
            </div>

            <div className="text-[0.65rem] mt-2 ml-1">
              ISIN: {selectedAsset ? selectedAsset?.isin : ""}
            </div>
            <div className="grid grid-cols-subgrid gap-4 col-start-2 col-span-3"></div>
          </div>
        </div>

        <div className="md:col-span-7 col-span-4 text-end whitespace-nowrap text-[0.70rem] font-bold">
          <div className="grid md:grid-cols-6 grid-cols-4 gap-2">
            <div className="">Realised profit</div>
            <div
              className={`flex justify-between ml-7 ${
                graphROI?.avg_realized < 0 ? "text-expense" : "text-secondary"
              }`}
            >
              <span>CHF</span>
              <span>
                {formatNumber(
                  (graphROI?.avg_realized ? graphROI.avg_realized : 0).toFixed(
                    2
                  )
                )}
              </span>
            </div>
            <div>INCOME</div>
            <div className="text-secondary flex justify-between ml-7">
              <span>CHF</span>
              <span>
                {formatNumber(
                  viewTransaction?.total_income
                    ? viewTransaction?.total_income
                    : 0
                )}
              </span>
            </div>
            <div>EXPENSE</div>
            <div className="text-expense flex justify-between ml-7">
              <span>CHF</span>
              <span>
                {formatNumber(
                  viewTransaction?.total_expense
                    ? viewTransaction?.total_expense
                    : 0
                )}
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-6 grid-cols-4 gap-2 mt-4">
            <div>Unrealised profit</div>
            <div
              className={`flex justify-between ml-7 ${
                graphROI?.avg_unrealized < 0 ? "text-expense" : "text-secondary"
              }`}
            >
              <span>CHF</span>
              <span>
                {formatNumber(
                  (graphROI?.avg_unrealized
                    ? graphROI.avg_unrealized
                    : 0
                  ).toFixed(2)
                )}
              </span>
            </div>
            <div>IN</div>
            <div className="text-secondary flex justify-between ml-7">
              <span>CHF</span>
              <span>
                {formatNumber(
                  viewTransaction?.total_in ? viewTransaction?.total_in : 0
                )}
              </span>
            </div>
            <div className="">OUT</div>
            <div className="text-expense flex justify-between ml-7">
              <span className="">CHF</span>
              <span className="">
                {formatNumber(
                  viewTransaction?.total_out ? viewTransaction?.total_out : 0
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="text-end">
          <CustomDropdown
            options={dropdownOptions}
            name={""}
            assetId={""}
            icon={<FaPlus />}
            direction={"right"}
            truncateText={truncateText}
            size={19}
            className="flex items-center justify-center w-12 h-12 rounded-full font-bold bg-secondary text-primary hover:bg-[#148f77]"
            onOptionSelect={(option) =>
              handleOptionSelect(option, "Create", {})
            }
          />
        </div>
      </div>

      <div className="border-b border-[rgb(35,135,159)] pt-3"></div>

      <div className="grid md:grid-cols-8 grid-cols-4 mt-2">
        {["Return", "Movements", "Documents"].map((btn) => (
          <button
            key={btn}
            className={selectedButton === btn ? "text-secondary font-bold" : ""}
            onClick={() => setSelectedButton(btn)}
          >
            {btn}
          </button>
        ))}
      </div>

      <div className="mt-5">
        {selectedButton === "Return" && (
          <ReturnComponent
            graphROI={graphROI}
            companyDetails={companyDetails}
          />
        )}
        {selectedButton === "Trade" && <TradeComponent />}
        {selectedButton === "Risk" && <RiskComponent />}
        {selectedButton === "Movements" && (
          <MovementComponent
            confirmDelete={confirmTransactionDelete}
            handleOptionSelect={handleOptionSelect}
            viewTransaction={viewTransaction}
            viewFutureTransaction={viewFutureTransaction}
            setLimit={setLimit}
            limit={limit}
            setPage={setPage}
            page={page}
          />
        )}
      </div>
      <CreateTransactionModal
        visible={modalVisible}
        singleTransactionData={singleTransactionData}
        actionTypes={actionTypes}
        fetchTransactionData={GetTransactionData}
        fetchFutureTransactionData={GetFutureTransactionData}
        GetRoiData={GetRoiData}
        viewTransaction={viewTransaction}
        onHide={() => {
          setModalVisible(false);
        }}
        SelectType={type}
        toast={toast}
        loading={loading}
        setLoading={setLoading}
        assetName={selectedAsset}
      />
    </>
  );
};

export default ViewTransaction;
